<template>
  <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData" :isImmagini="true" :isPrestazioni="true" :isAllegati="false" :btnFirmaVisible="btnFirmaVisible" @updateFirma="onFirmaUpdate">
    <template slot="tab-content-event">
      <gastro-visita-proctologica-view-component @update="onUpdateJsonData" :key="gastroVisitaProctologicaKey"></gastro-visita-proctologica-view-component>
    </template>
  </eventi-view-component>
</template>

<script>
// import axios from "axios";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import GastroVisitaProctologicaViewComponent from "../components/GastroVisitaProctologicaViewComponent.vue";
export default {
  components: { EventiViewComponent, GastroVisitaProctologicaViewComponent },
  mixins: [UtilityMixin, EventiMixin],
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      titoloEvento: "VISITA PROCTOLOGICA",
      linkback: null,
      linkedit: null,
      btnFirmaVisible: true,
      jsonData: {},
      pathResource: "/gastrovisitaproctologica",
      tabIndex: 0,
      gastroVisitaProctologicaKey: 0,
      id: null,
      pathRestValidation: "/validation",
      isThisFirmato: false,
      showModalLoading: false,
      linkPrintData: null,
    };
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    let me = this;
    me.jsonData.idPaziente = this.$route.query.idPaziente;
    me.id = this.$route.params.id;
    me.gastroVisitaProctologicaKey++;
  },

  methods: {
    updateStatoFirma(firmato) {
      console.log(firmato);
    },
    onFirmaUpdate() {
      let me = this;
      me.btnFirmaVisible = false;
      me.gastroVisitaProctologicaKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
      if (me.jsonData.firma) {
        me.btnFirmaVisible = false;
      } else {
        me.btnFirmaVisible = true;
      }
      me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
    },
  },
};
</script>

<style></style>
